import type { State } from '../index';
import { FULL_WIDTH_BREAK_POINT } from '~/embed/constants';
import { getCookieByName } from '~/utils/cookies';

export const getEmbedParams = (): State['embed'] => {
  if (import.meta.env.MODE === 'script') {
    return {
      appName: '',
      appVersion: '',
      userId: '',
      clickId: '',
      vcmId: '',
      channelId: '',
      channelDepth: 0,
      mainChannelId: '',
      friendlyUrl: '',
      canonicalUrl: '',
      contentWidth: 0,
      isFullWidth: false,
      isOpen: false,
    };
  }

  const url = new URL(window.location.href);
  const appNameCookie = getCookieByName('appName') ?? '';
  const contentWidth =
    window.parent === window.self
      ? window.innerWidth
      : parseInt(url.searchParams.get('contentWidth') ?? '') || window.innerWidth;
  const clickId = getCookieByName('click_id') ?? '';
  let appVersion = getCookieByName('appverid') ?? '';
  let userId = getCookieByName('user_id') ?? '';
  let appName = 'unknown';

  switch (true) {
    case Boolean(appNameCookie):
      appName = appNameCookie;
      break;

    case url.hostname.includes('mako'):
      appName = 'mako';
      break;

    case url.hostname.includes('n12'):
      appName = 'n12';
      break;

    case url.hostname.includes('localhost'):
      appName = 'mako';
      appVersion = getCookieByName('appverid') ?? ''; // truthy value means 'in-app mode'
      userId = getCookieByName('user_id') ?? '99a859d7d8a4eea944d9a9f3c6c05483';
      break;
  }

  return {
    appName,
    appVersion,
    userId,
    clickId,
    vcmId: url.searchParams.get('vcmId') ?? '',
    channelId: url.searchParams.get('channelId') ?? '',
    channelDepth: parseInt(url.searchParams.get('channelDepth') ?? '') || 0,
    mainChannelId: url.searchParams.get('mainChannelId') ?? '',
    friendlyUrl: url.searchParams.get('friendlyUrl') ?? '',
    canonicalUrl: url.searchParams.get('canonicalUrl') ?? '',
    isFullWidth: contentWidth <= FULL_WIDTH_BREAK_POINT,
    contentWidth,

    // in native app there is no drawer, widget is always 'open':
    isOpen: url.searchParams.get('isOpen') === 'true' || Boolean(appVersion) || window.parent === window.self,
  };
};
